module.exports = __webpack_public_path__ + "img/account.f95912f.svg";